// TODO: REMOVE AFTER Select AND InputWithSelect REFACTOR
/* eslint-disable @typescript-eslint/ban-ts-comment */

import { SetStateAction, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { produce } from "immer";

import InputWithSelect from "shared/components/Form/InputWithSelect";
import Select from "shared/components/Form/Select";
import { WizardData } from "shared/components/WizardNew/types";

import { getCitiesList } from "shared/data/location";

import { SAFE_MODE_WIZARD } from "shared/constants/wizard";

import { WizardStore, WizardType } from "shared/context/WizardStoreContext";

import { simplyClick } from "shared/helpers/analytics";
import { getCitiesValues } from "shared/helpers/location";
import { setStepperState } from "shared/helpers/wizard";

import { useWizard, WizardStep } from "shared/hooks/useWizard";

import { getCity, getCountries } from "shared/services/location";

import styles from "@platformAssets/components/Wizard.module.scss";

type AnswerLocation = {
  residence_city: string;
  residence_country: string;
};

type Props = { wizardData: WizardData };

const WizardLocation = ({ wizardData }: Props) => {
  const { t } = useTranslation("wizard");

  const [wizardStore, setWizardStore] = useContext(WizardStore);

  const wizard = useWizard(wizardData);

  const { analytics } = wizard[WizardStep.Location];

  const { mode } = wizardData;

  const locationData = wizardStore.answers?.location as AnswerLocation;
  const [countries, setCountries] = useState({});
  const [cities, setCities] = useState({ city: [], country: "" });
  const [clearSearch, setClearSearch] = useState(false);
  const [upload, setUpload] = useState(false);
  const [send, setSend] = useState(false);
  const [error, setError] = useState({ city: null, country: null });

  useEffect(() => {
    if (mode === SAFE_MODE_WIZARD) {
      setWizardStore(
        setStepperState(
          wizardStore,
          3,
          mode
        ) as unknown as SetStateAction<WizardType>
      );
    }
  }, [mode]);

  useEffect(() => {
    setWizardStore(
      produce((wizardStore: WizardType) => {
        wizardStore.answers = {
          location: {
            residence_city: wizardData?.residence_city.toString() ?? null,
            residence_country: wizardData?.residence_country ?? null,
          },
        };
      })
    );
  }, [wizardData]);

  /**
   * Effect for get Countries list
   */
  useEffect(() => {
    getCountries().then(({ data }: any) => {
      if (!data.success) {
        return false;
      }
      setCountries(data.data);
    });

    if (
      locationData?.residence_country &&
      locationData?.residence_city?.length !== 0
    ) {
      setSend(true);
      getCity(locationData.residence_country, locationData.residence_city)
        .then(({ data }) => {
          setSend(false);
          if (data.success) {
            setUpload(true);
            setSend(false);
          }
          if (!data.success) {
            setSend(false);
            return false;
          }
          setSend(false);
          setCities({ ...cities, city: data?.data });
        })
        .catch((error) => {
          console.log(error.message);
          setSend(false);
        });
    }
  }, [locationData]);

  /**
   * Get cities list by search text
   * @param {string} value
   */
  const getCitiesListByValue = (value: string) => {
    if (value.length >= 2) {
      setSend(true);
      getCitiesList(
        locationData?.residence_country,
        value,
        (result: any) => {
          setSend(false);
          setCities(result);
        },
        () => {
          console.log("Cannot get cities list");
        }
      );
    }
  };

  /**
   * Handle change country
   */
  const handleChangeCountry = (value: string) => {
    setError({ ...error, country: null });

    if (analytics?.chooseCountry) {
      analytics?.chooseCountry?.forEach((item: string) => {
        simplyClick(item, null, false);
      });
    }

    setWizardStore(
      produce((wizardStore: WizardType) => {
        wizardStore.answers = {
          location: {
            residence_country: value,
          },
        };
      })
    );

    setClearSearch(true);
  };

  /**
   * Handle change city
   * @param {string} value
   */
  const handleChangeCity = (value: string) => {
    setError({ ...error, city: null });

    if (analytics?.chooseCity) {
      analytics?.chooseCity?.forEach((item: string) => {
        simplyClick(item, null, false);
      });
    }

    setWizardStore(
      produce((wizardStore: WizardType) => {
        wizardStore.answers.location.residence_city = value;
      })
    );
  };

  return (
    <div className={styles.wizardRangesContainer}>
      <div className={styles.wizardRangeWrapper}>
        <div className={styles.wizardRangeLabel}>
          {wizard?.[WizardStep.Location]?.criteria?.residence_country.label}
        </div>
        <Select
          name="residence_country"
          // TODO: REMOVE AFTER SELECT REFACTOR
          className={styles.countrySelect}
          values={countries}
          // TODO: REMOVE AFTER SELECT REFACTOR
          // @ts-expect-error
          value={countries[locationData?.residence_country] ?? ""}
          handleChange={handleChangeCountry}
          errorText={error.country}
          error={Boolean(error.country)}
        />
      </div>

      <div className={styles.wizardRangeWrapper}>
        <div className={styles.wizardRangeLabel}>
          {wizard?.[WizardStep.Location]?.criteria?.residence_city.label}
        </div>

        <InputWithSelect
          // TODO: REMOVE AFTER InputWithSelect REFACTOR
          // @ts-expect-error
          className={styles.citySelect}
          attribute={locationData?.residence_city}
          // TODO: REMOVE AFTER InputWithSelect REFACTOR
          // @ts-expect-error
          value={getCitiesValues(cities.city)[locationData?.residence_city]}
          values={getCitiesValues(cities.city)}
          name="residence_city"
          change={handleChangeCity}
          getValues={getCitiesListByValue}
          load={upload}
          send={send}
          clearError={() => setError({ ...error, city: null })}
          errorText={error?.city}
          emptyValueError={t("wizard.cityEmptyValueError")}
          clearSearch={clearSearch}
          setClearSearch={setClearSearch}
        />
      </div>
    </div>
  );
};

export { WizardLocation };
